export default __webpack_public_path__ + "static/media/home_menu_item.71ffd5ca.svg";